module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-5 mt-3"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "d-flex": "",
      "align-end": "",
      "justify-start": "",
      "mb-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('label', [_vm._v("Tipo de cambio")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset mt-2",
    attrs: {
      "type": "text"
    },
    on: {
      "blur": function($event) {
        _vm.changeAmounts(_vm.currencySelected)
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.changeAmounts(_vm.currencySelected)
      }
    },
    model: {
      value: (_vm.exchangeRate),
      callback: function($$v) {
        _vm.exchangeRate = $$v
      },
      expression: "exchangeRate"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('label', [_vm._v("Moneda")]), _vm._v(" "), _c('v-select', {
    staticClass: "filter-select mt-2",
    attrs: {
      "item-text": "code",
      "item-value": "code",
      "label": "Moneda",
      "items": _vm.currencies,
      "hide-details": "",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "input": _vm.changeAmounts
    },
    model: {
      value: (_vm.currencySelected),
      callback: function($$v) {
        _vm.currencySelected = $$v
      },
      expression: "currencySelected"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('label', [_vm._v("Tipo de documento")]), _vm._v(" "), _c('v-select', {
    staticClass: "filter-select mt-2",
    attrs: {
      "item-text": "name",
      "item-value": "code",
      "items": _vm.typeDocuments,
      "hide-details": "",
      "single-line": ""
    },
    on: {
      "change": _vm.changeTypeDocument
    },
    model: {
      value: (_vm.typeDocumentCode),
      callback: function($$v) {
        _vm.typeDocumentCode = $$v
      },
      expression: "typeDocumentCode"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('label', [_vm._v("Tipo de pago")]), _vm._v(" "), _c('v-select', {
    staticClass: "filter-select mt-2",
    attrs: {
      "item-text": "name",
      "item-value": "code",
      "items": _vm.typePayments,
      "hide-details": "",
      "single-line": ""
    },
    model: {
      value: (_vm.typePaymentCode),
      callback: function($$v) {
        _vm.typePaymentCode = $$v
      },
      expression: "typePaymentCode"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('select-button', {
    attrs: {
      "label-text": "Banco",
      "item-text": "name",
      "item-value": "id",
      "items": _vm.banks
    },
    model: {
      value: (_vm.bankSelectedId),
      callback: function($$v) {
        _vm.bankSelectedId = $$v
      },
      expression: "bankSelectedId"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "mb-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('select-button', {
    attrs: {
      "label-text": "Días de crédito",
      "items": _vm.creditDays
    },
    model: {
      value: (_vm.creditDaysSelected),
      callback: function($$v) {
        _vm.creditDaysSelected = $$v
      },
      expression: "creditDaysSelected"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('input-text', {
    attrs: {
      "label-text": "Monto total de factura"
    },
    model: {
      value: (_vm.totalAmount),
      callback: function($$v) {
        _vm.totalAmount = $$v
      },
      expression: "totalAmount"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('input-text', {
    attrs: {
      "label-text": "Adelanto"
    },
    model: {
      value: (_vm.moneyAdvance),
      callback: function($$v) {
        _vm.moneyAdvance = $$v
      },
      expression: "moneyAdvance"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "mb-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "pl-2": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select filter-select-indicator",
    attrs: {
      "item-text": "name",
      "items": _vm.documentsTypes,
      "hide-details": "",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.documentType),
      callback: function($$v) {
        _vm.documentType = $$v
      },
      expression: "documentType"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset input-form-select",
    attrs: {
      "type": "text"
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.searchCustomerSale($event)
      },
      "blur": _vm.searchCustomerSale
    },
    model: {
      value: (_vm.numDocument),
      callback: function($$v) {
        _vm.numDocument = $$v
      },
      expression: "numDocument"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "md3": ""
    }
  }, [_c('input-text', {
    attrs: {
      "value": _vm.customerData
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showExoneration),
      expression: "showExoneration"
    }],
    attrs: {
      "xs3": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "input-checkbox input-booking",
    attrs: {
      "label": "Exonerar impuestos",
      "color": "info",
      "hide-details": ""
    },
    model: {
      value: (_vm.flagTaxes),
      callback: function($$v) {
        _vm.flagTaxes = $$v
      },
      expression: "flagTaxes"
    }
  })], 1)], 1), _vm._v(" "), _c('table-run', {
    staticClass: "no-selectable-table no-search-table",
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.productsLocal,
      "include-delete": false,
      "include-export-to-excel": false,
      "include-search": false,
      "selectable": false
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.row.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.categoryName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.quantity))]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t" + _vm._s(_vm._f("currency")(_vm._f("round")(props.row.price), _vm.symbol)) + "\n\t\t\t\t"), (!props.row.flagIgv && !_vm.booking.subsidiary.flagTaxes) ? _c('v-btn', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip:top",
            value: ({
              html: 'Se aplicarán impuestos'
            }),
            expression: "{ html: 'Se aplicarán impuestos' }",
            arg: "top"
          }],
          staticClass: "warning--text",
          attrs: {
            "icon": ""
          }
        }, [_c('v-icon', [_vm._v("warning")])], 1) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.salDocumentsNumber))])]
      }
    }])
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-5": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-save",
    attrs: {
      "disabled": _vm.quotationDisabled
    },
    on: {
      "click": _vm.generateQuotation
    }
  }, [_vm._v("\n\t\t\t\tGuardar\n\t\t\t")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76aa34e1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/calendar/ListPrepayment.vue
// module id = 1675
// module chunks = 26